import { Car, Check } from 'lucide-react'
import UpdateSectionCard from '@/components/shared/claim-updates/UpdateSectionCard'

const checklistItems = [
  'Managing your claim from start to finish',
  'Reviewing claim information and supporting documentation',
  'Communicating with lenders and finance providers',
  'Monitoring regulatory and legal developments',
  'Preparing your claim for the next stage',
]

const WorkChecklist = () => (
  <UpdateSectionCard
    icon={Car}
    heading="The work we are doing for you"
    className="bg-[#F1F1F1]"
  >
    <ul className="space-y-3">
      {checklistItems.map(item => (
        <li key={item} className="flex items-start gap-3">
          <Check
            className="mt-0.5 h-5 w-5 shrink-0 text-[#FF914D]"
            aria-hidden="true"
          />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  </UpdateSectionCard>
)

export default WorkChecklist
